module.exports = "/_next/static/images/3-3397aa29a3e7dfd47bf27d46a91b8e53.png";